import { BigNumber } from "@ethersproject/bignumber"

import { ChainId } from "@/web3/constants/chains"
import {
  getZKsyncEraMainnetReference,
  getZKsyncSepoliaTestnetReference,
} from "@/web3/helpers/chainReference"
import createViemPublicProvider from "@/web3/providers/createViemPublicProvider"
import { PopulatedTransaction } from "ethers"
import { getChainIdParams } from "@/web3/helpers/chainId"

// Specific constants for zkSync according to recommendations
const ZK_ESTIMATE_GAS_SCALE_FACTOR = 1.3
const ZK_ESTIMATE_GAS_ACCEPTABLE_OVERESTIMATION = 5000
export const ZK_DEFAULT_GAS_LIMIT = BigNumber.from(100000)

/**
 * Estimates gas for Safe transactions on zkSync
 */

export async function estimateZkSyncGas(chainId: ChainId, tx: PopulatedTransaction): Promise<BigNumber | null> {
  try {
    const { reference } = getChainIdParams(chainId)
    if (!isZkSyncNetwork(reference)) {
      throw new Error("Chain is not zkSync")
    }

    const provider = createViemPublicProvider(chainId)

    if (!provider) {
      throw new Error("No provider found for zkSync")
    }

    // Use zks_estimateFee method specific to zkSync
    const response = await provider.transport.request({
      method: "zks_estimateGasL1ToL2",
      params: [
        {
          from: tx.from,
          to: tx.to,
          data: tx.data,
          value: tx.value,
        },
      ],
    })

    const adjustedGasLimit = BigNumber.from(response)
      .mul(Math.floor(ZK_ESTIMATE_GAS_SCALE_FACTOR * 100))
      .div(100)
      .add(ZK_ESTIMATE_GAS_ACCEPTABLE_OVERESTIMATION)

    return adjustedGasLimit
  } catch (error) {
    console.error("Error estimating gas in zkSync:", error)

    return null
  }
}

/**
 * Checks if the current chain is zkSync
 */
export function isZkSyncNetwork(chainId: number): boolean {
  const zkSyncMainnetReference = getZKsyncEraMainnetReference()
  const zkSyncSepoliaTestnetReference = getZKsyncSepoliaTestnetReference()

  return (
    chainId === zkSyncMainnetReference ||
    chainId === zkSyncSepoliaTestnetReference
  )
}
